/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 4 hook(s) need dependency review; fix each and remove this directive */
import { getBackendUrl } from "@Utils";
import { useTranslation } from "@i18n";
import { useEffect, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { useDispatch, useSelector } from "react-redux";
import axiosWrapper from "@AxiosWrapper";
import type {
  DatabankViewData,
  GetDataBankViewResponse,
  QueriesDataResponse,
} from "@ServerTypes/queries/queries.schema";
import { setDatabankData } from "@Reducers/Databank";
import { RootState } from "@Reducers/index";

function Views({ fileVersionId, id, onChange }: any) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const DefaultViewName = "Default View";
  const DefaultViews = {
    [DefaultViewName]: {
      query: "",
      columns: [],
    },
  };
  const filesData = useSelector((state: RootState) => state.filesData);
  const {
    viewsLoaded,
    views = {},
    selectedView = DefaultViewName,
    updateCurrentView = false,
  } = useSelector((state: RootState) => state.Databank[id]?.[fileVersionId] || {}) as DatabankViewData & {
    views?: Record<string, DatabankViewData>;
    updateCurrentView?: boolean;
  };

  const [showViewDropdown, setShowViewDropdown] = useState(false);

  const handleViewDropdownClick = () => {
    setShowViewDropdown((showViewDropdown) => !showViewDropdown);
  };

  const init = async () => {
    const response = await axiosWrapper.post<GetDataBankViewResponse>(`${getBackendUrl()}/queries/getDataBankView`, {
      fileId: filesData[fileVersionId]?.fileId,
    });
    const data = response.data.data as any;
    if (data) {
      // Support new format { views, selectedView } and old format { [viewName]: { ... } }
      const isNewFormat = data.views && typeof data.views === "object" && !Array.isArray(data.views);
      const viewsData = isNewFormat ? data.views : data;
      const lastSelectedView: string = isNewFormat ? data.selectedView || DefaultViewName : DefaultViewName;
      const firstViewName: string = Object.keys(viewsData)[0] || DefaultViewName;
      const restoredSelectedView: string = viewsData[lastSelectedView] ? lastSelectedView : firstViewName;
      const selectedViewData = viewsData[restoredSelectedView] || {};
      dispatch(
        setDatabankData({
          data: {
            views: viewsData,
            selectedView: restoredSelectedView,
            filteredColumns: selectedViewData.columns || [],
            queryId: selectedViewData.query || "",
            group: selectedViewData.group || "",
            viewsLoaded: true,
          },
          fileVersionId,
          id,
        }),
      );
    } else {
      dispatch(
        setDatabankData({
          data: {
            views: DefaultViews,
            selectedView: DefaultViewName,
            filteredColumns: [],
            queryId: "",
            viewsLoaded: true,
          },
          fileVersionId,
          id,
        }),
      );
    }
  };

  useEffect(() => {
    init();
  }, []);

  const saveView = async (fileId: any, view: any) => {
    await axiosWrapper.post<QueriesDataResponse>(`${getBackendUrl()}/queries/saveDataBankView`, {
      fileId,
      dataBankViews: view,
    });
  };

  const handleUpdateView = async () => {
    await saveView(filesData[fileVersionId]?.fileId, { views, selectedView });
  };

  useEffect(() => {
    if (viewsLoaded) {
      handleUpdateView();
    }
  }, [views]);

  useEffect(() => {
    if (viewsLoaded) {
      handleUpdateView();
    }
  }, [selectedView]);

  useEffect(() => {
    if (updateCurrentView) {
      handleUpdateView();
    }
  }, [updateCurrentView]);

  const handleCreateNewView = async () => {
    const tempViewData: Record<string, DatabankViewData> = { ...views };
    const currentView: DatabankViewData = tempViewData[selectedView] || {};
    tempViewData[`View ${Object.keys(tempViewData).length + 1}`] = {
      columns: currentView.columns,
      query: currentView.query,
      group: currentView.group,
      sortConditions: currentView.sortConditions,
      filterConditions: currentView.filterConditions,
      groupConditions: currentView.groupConditions,
    };

    await saveView(filesData[fileVersionId]?.fileId, { views: tempViewData, selectedView });

    dispatch(
      setDatabankData({
        data: {
          views: tempViewData,
        },
        fileVersionId,
        id,
      }),
    );
  };

  const handleViewSelection = (e: any) => {
    const selectedName = e.currentTarget.attributes["data-name"].value;
    dispatch(
      setDatabankData({
        data: {
          selectedView: selectedName,
        },
        fileVersionId,
        id,
      }),
    );

    setShowViewDropdown(false);
    onChange(views[selectedName]);
  };

  return (
    <div>
      <div className="flex items-center" onClick={handleViewDropdownClick}>
        <span>{selectedView}</span>
        <MdArrowDropDown size="1.5rem" />
      </div>
      {showViewDropdown && (
        <div className="fixed z-[10] flex flex-col gap-4 bg-white p-5 shadow-[0.25rem_0.5rem_1.25rem_0_rgba(0,0,0,0.3)]">
          <div className="flex flex-col gap-4">
            {Object.keys(views).map((data: string, index: number) => (
              <div onClick={handleViewSelection} key={index} data-name={data}>
                {data}
              </div>
            ))}
          </div>
          <div>
            <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={handleCreateNewView}>
              {t("Create View")}
            </ButtonComponent>
          </div>
        </div>
      )}
    </div>
  );
}

export default Views;
